module.exports = __webpack_public_path__ + "static/media/email-icon.d5c7b246.svg";